import BlueTableHeading from "../../../../common/AdminCommonComponents/BlueTableHeading/BlueTableHeading"
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import DynamicTableFilters from "../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters"

const SavedPaymentMethods = () => {
  const payoutsData = [
    {
      sr: "1",
      ID: "001",
      name: "John Doe",
      paymentMethod: "Visa*******1234",
      type: "Card",
      savedDate: "10/02/2025",
      lastUse: "10/02/2025",
      default: "Default",
      status: "Active",
    },
    {
      sr: "2",
      ID: "001",
      name: "John Doe",
      paymentMethod: "Jaazcash",
      type: "Digital",
      savedDate: "10/02/2025",
      lastUse: "10/02/2025",
      default: "Default",
      status: "Active",
    },
    {
      sr: "3",
      ID: "001",
      name: "John Doe",
      paymentMethod: "Visa*******1234",
      type: "Card",
      savedDate: "10/02/2025",
      lastUse: "10/02/2025",
      default: "Default",
      status: "Active",
    },
    {
      sr: "4",
      ID: "001",
      name: "John Doe",
      paymentMethod: "Visa*******1234",
      type: "Card",
      savedDate: "10/02/2025",
      lastUse: "10/02/2025",
      default: "Default",
      status: "Active",
    },
    {
      sr: "5",
      ID: "001",
      name: "John Doe",
      paymentMethod: "Visa*******1234",
      type: "Card",
      savedDate: "10/02/2025",
      lastUse: "10/02/2025",
      default: "Default",
      status: "Active",
    },
    {
      sr: "6",
      ID: "001",
      name: "John Doe",
      paymentMethod: "Visa*******1234",
      type: "Card",
      savedDate: "10/02/2025",
      lastUse: "10/02/2025",
      default: "Default",
      status: "Active",
    },
  ]

  const payoutsCols = [
    {
      name: 'Sr. No',
      selector: row => row.sr,
      grow: 0.3
    },
    {
      name: 'ID',
      selector: row => row.ID,
      grow: 0.3
    },
    {
      name: 'Name',
      selector: row => row.name,
    },
    {
      name: 'Payment Method',
      selector: row => row.paymentMethod,
    },
    {
      name: 'Type',
      selector: row => row.type,
    },
    {
      name: 'Saved Date',
      selector: row => row.savedDate,
    },
    {
      name: 'Last Use',
      selector: row => row.lastUse,
    },
    {
      name: 'Default',
      selector: row => row.default,
    },
    {
      name: 'Status',
      selector: row => row.status,
    },
    {
      name: "Actions",
      cell: () => <ActionButton options={actions} />,
      center: 'true'
    }
  ];
  
  const actions = [
    { label: 'View Details' },
    { label: 'Edit' },
    { label: 'Delete' },
  ]

  return (
    <div className="bg-white shadow mt-3">
      <BlueTableHeading className="px-4 py-3 fw-semibold fs-5">Saved Payment Methods</BlueTableHeading>

      <DynamicTableFilters componentName="Pricing Finance & Payment Payment Methods" />

      <div className="p-3">
        <DynamicDatatable data={payoutsData} columns={payoutsCols} type="gray" pagination />
      </div>
    </div>
  )
}

export default SavedPaymentMethods
